"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeQuickBetSaga = makeQuickBetSaga;
exports.betsProviderSaga = betsProviderSaga;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const slice_1 = require("./slice");
const SettingsProvider_1 = require("../SettingsProvider");
const AccountProvider_1 = require("../AccountProvider");
const LanguagesProvider_1 = require("../LanguagesProvider");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/bets/api");
function* makeQuickBetSaga(action) {
    const { saveAny, outcomeId, outcome } = action.payload;
    const quickBetAmount = yield (0, effects_1.select)(SettingsProvider_1.selectSettingsDataProp, 'quickBetAmount');
    if (!quickBetAmount) {
        return;
    }
    yield (0, effects_1.put)(slice_1.betsProviderActions.makeQuickBetLoading({ outcomeId }));
    try {
        const accountId = yield (0, effects_1.select)(AccountProvider_1.selectAccountId);
        const locale = yield (0, effects_1.select)(LanguagesProvider_1.selectCurrentLangCode);
        const bet = {
            outcomes: [outcome],
            bet: quickBetAmount,
            systemSize: 0,
            betType: betweb_openapi_axios_1.BetType.Ordinar,
            bonusWallet: false,
        };
        const params = {
            newBetList: {
                items: [bet],
                saveAny,
                betCreationMethod: betweb_openapi_axios_1.BetCreationMethod.QuickBet,
                accountId,
            },
            locale,
        };
        const { data } = yield (0, effects_1.call)(api_1.makeBet, params);
        yield (0, effects_1.put)(slice_1.betsProviderActions.makeQuickBetSuccess({
            outcomeId,
            result: data.items[0],
        }));
    }
    catch (e) {
        const errorInfo = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.betsProviderActions.makeQuickBetError({
            error: errorInfo,
            outcome,
            outcomeId,
        }));
    }
}
function* betsProviderSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeEvery)(slice_1.betsProviderActions.makeQuickBet, makeQuickBetSaga)]);
}
//# sourceMappingURL=saga.js.map